import { BaseModel } from "model/BaseModel";
import MarcaVeiculo from "./MarcaVeiculo";
import VeiculoItemInspecao from "./VeiculoItemInspecao";
import Arquivo from "model/arquivo/Arquivo";
import UsuarioVeiculo from "./UsuarioVeiculo";

export default class Veiculo implements BaseModel {

    id: number;
    marca: MarcaVeiculo;
    modelo: string;
    placa: string;
    renavam: number | null;
    chassi: string | null;
    horimetro: number | null;
    quilometragem: number | null;
    identificador: string;
    codigo: string | null;
    codigoSisatec: number | null;
    dataAtualizacaoKm: Date | null;
    itensInspecao: Array<VeiculoItemInspecao>;
    usuariosVeiculo: Array<UsuarioVeiculo>;
    arquivos: Array<Arquivo>;
    

    constructor(
        id = 0,
        codigo = null,
        marca = new MarcaVeiculo(),
        modelo = "",
        placa = "",
        renavam = null,
        chassi = "",
        horimetro = 0,
        quilometragem = 0,
        identificador = "",
        codigoSisatec = null,
        dataAtualizacaoKm = null,
        usuariosVeiculo = [],
        itensInspecao = [],
        arquivos = []
    ) {
        this.id = id;
        this.codigo = codigo;
        this.marca = marca;
        this.modelo = modelo;
        this.placa = placa;
        this.renavam = renavam;
        this.chassi = chassi;
        this.horimetro = horimetro;
        this.quilometragem = quilometragem;
        this.identificador = identificador;
        this.codigoSisatec = codigoSisatec;
        this.dataAtualizacaoKm = dataAtualizacaoKm;
        this.usuariosVeiculo = usuariosVeiculo;
        this.itensInspecao = itensInspecao;
        this.arquivos = arquivos;
    }

}